import { v4 as uuidv4 } from "uuid";
export class EntryActionModel {
    constructor() {
        this.id = uuidv4();
        this.entryId = "";
        this.description = "";
        this.actionDateAsString = "";
        this.actionVisible = false;
    }
}
export default class EntryAction extends EntryActionModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
